module.exports = __webpack_public_path__ + "../../mstile-310x150.png";


// WEBPACK FOOTER //
// ./~/file-loader/!./~/url-loader??ref--4-0!./~/image-webpack-loader??ref--4-1!./~/file-loader??ref--5-0!./~/image-webpack-loader??ref--5-1!./src/_assets/img/mstile-310x150.png